<div class="stream-page">
  <div class="stream-page__container stream-page__container-top">
    <h1 class="stream-page__marketplace-title">Marketplace</h1>

    <!--commented for ticket KB-1378-->
<!--    <div class="separator"></div>-->
<!--    <section>-->
<!--      <h2 class="title">-->
<!--        <img-->
<!--          alt=""-->
<!--          class="title__icon"-->
<!--          src="assets/ui/images/svg/classes.svg"-->
<!--        />-->
<!--        <div>DIGITAL EXPERIENCES</div>-->
<!--      </h2>-->
<!--    </section>-->

    <div class="separator"></div>

    <section>
      <h2 class="title">
        <img
          alt="title-icon"
          class="title__icon"
          src="assets/ui/images/svg/products.svg"
          width="54"
          height="54"
        />
        <div>PRODUCTS COMING SOON</div>
      </h2>

      <!--commented for ticket KB-1974-->
<!--      <div class="product-card-list">-->
<!--        <app-shop-product-card-->
<!--          *ngFor="let product of products$ | async;  trackBy: trackByFn"-->
<!--          [product]="product"-->
<!--          [isTileCard]="true"-->
<!--          source="marketplace_shop"-->
<!--        ></app-shop-product-card>-->
<!--      </div>-->
    </section>
  </div>
</div>
